import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        mode: {
            lvl: 0,
            label: 'no mode select'
        },
        audioRecorder: {},
        character: {},
        practiceText: [
            {
                id: 1,
                text: '<ruby>練習<rt>れんしゅう</rt></ruby>モードを<ruby>始<rt>はじ</rt></ruby>めます。</br>' +
                    'ここをタップして<ruby>表示<rt>ひょうじ</rt></ruby>されたテキストを<ruby>私<rt>わたし</rt></ruby>に<ruby>聞<rt>き</rt></ruby>かせてください。'
            }, {
                id: 2,
                text: 'こんにちは！</br> ' +
                    '<ruby>最近海外<rt>さいきんかいがい</rt></ruby>から<ruby>日本<rt>にほん</rt></ruby>に<ruby>来<rt>き</rt></ruby>たばかりです！\n' +
                    'この<ruby>辺<rt>あた</rt></ruby>りにいいカフェがあるか<ruby>知<rt>し</rt></ruby>りませんか？'
            }
        ],
        practiceResult: {
            noNative: {
                result: 'カフィ？えっと…ごめんなさい…！もう1<ruby>回<rt>かい</rt></ruby>お<ruby>願<rt>ねが</rt></ruby>いします。。\n',
                advice: '<ruby>残念<rt>ざんねん</rt></ruby>…！<br>' +
                    'もっと<ruby>発音<rt>はつおん</rt></ruby>がんばりましょう。。',
            },
            medium: {
                result: 'えっとカフェならあちらの<ruby>通<rt>とお</rt></ruby>りに<ruby>行<rt>い</rt></ruby>' +
                    'けばあると<ruby>思<rt>おも</rt></ruby>いますよ！\n',
                advice: 'あとちょっと！' +
                    'もう<ruby>少<rt>すこ</rt></ruby>し<ruby>発音<rt>はつおん</rt></ruby>がんばって<ruby>話<rt>はな</rt></ruby>' +
                    'してくれたらもっとお<ruby>話<rt>はなし</rt></ruby>したくなります。'
            },
            native: {
                result: 'こんにちは！' +
                    'カフェ<ruby>巡<rt>めぐ</rt></ruby>りがお<ruby>好<rt>す</rt></ruby>きなんですか？\n' +
                    'ついさいきん<ruby>新<rt>あた</rt></ruby>しいお<ruby>店<rt>みせ</rt></ruby>ができたのですが、そちらがオススメですよ！',
                advice: '<p><ruby>成功</ruby>！</br><ruby>魅力的</ruby>な<ruby>話し方</ruby>だね！</p>'
            }
        },
        freeTalk: [
            {
                id: 1,
                text: '<ruby>本番<rt>ほんばん</rt></ruby>だから、<ruby>自由<rt>じゆう</rt></ruby>にお' +
                    '<ruby>話<rt>はなし</rt></ruby>かけて<ruby>見<rt>み</rt></ruby>てね！'
            }
        ],
        freeTalkResult: {
            noNative: {
                result: 'えっと…ごめんなさい…！もう1<ruby>回<rt>かい</rt></ruby>お<ruby>願<rt>ねが</rt></ruby>いします。。',
                advice: '<ruby>残念<rt>ざんねん</rt></ruby>…！<br></br>' +
                    'もっと<ruby>発音<rt>はつおん</rt></ruby>がんばりましょう。。',
            },
            medium: {
                result: 'なるほど。',
                advice: 'あとちょっと！' +
                    'もう<ruby>少<rt>すこ</rt></ruby>し<ruby>発音<rt>はつおん</rt></ruby>がんばって<ruby>話<rt>はな</rt></ruby>' +
                    'してくれたらもっとお<ruby>話<rt>はなし</rt></ruby>したくなります。'
            },
            native: {
                result: 'わ〜<ruby>素敵<rt>すてき</rt></ruby>ですね！！',
                advice: '<p><ruby>成功</ruby>！</br><ruby>魅力的</ruby>な<ruby>話し方</ruby>だね！</p>'
            }
        }
        ,
        result: {
            progress: 0,
            status: -2
        }
    },
    getters: {
        getCharacter: state => {
            return state.character
        },
        getPracticeText: state => {
            return state.practiceText
        },
        getResult: state => {
            return state.result
        },
        getResultNoNative: state => {
            return state.practiceResult.noNative;
        },
        getResultMedium: state => {
            return state.practiceResult.medium;
        },
        getResultNative: state => {
            return state.practiceResult.native;
        },
        getFreeTalkNoNative: state => {
            return state.freeTalkResult.noNative;
        },
        getFreeTalkMedium: state => {
            return state.freeTalkResult.medium;
        },
        getFreeTalkNative: state => {
            return state.freeTalkResult.native;
        },
        getMode: state => {
            return state.mode.label;
        },
        getAudioRecorder: state => {
            return state.audioRecorder;
        }
    },
    mutations: {
        chooseCharacter(state, payload) {
            state.character = payload;
        },
        setResult(state, payload) {
            state.result.progress = payload.progress.progress_percent;
            state.result.status = payload.status.status_code;
        },
        setMode(state, payload) {
            state.mode.label = payload;
        },
        setAudioRecorder(state, payload) {
            state.audioRecorder = payload;
        }
    },
    actions: {
        chooseCharacter: (context, payload) => {
            context.commit('chooseCharacter', payload);
        },
        setResult: (context, payload) => {
            context.commit('setResult', payload);
        },
        setMode: (context, payload) => {
            context.commit('setMode', payload);
        },
        setAudioRecorder: (context, payload) => {
            context.commit('setAudioRecorder', payload);
        }
    }
})
